import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import { LocaleProvider } from '@/context/LocaleContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Landing from '@/pages/Landing';
import AuthCallback from '@/pages/AuthCallback';
import Dashboard from '@/pages/Dashboard';
import SongLibrary from '@/pages/SongLibrary';
import SongDetail from '@/pages/SongDetail';
import Courses from '@/pages/Courses';
import AITutor from '@/pages/AITutor';
import Community from '@/pages/Community';
import Profile from '@/pages/Profile';
import Admin from '@/pages/Admin';
import Playlists from '@/pages/Playlists';
import PlaylistDetail from '@/pages/PlaylistDetail';
import Pro from '@/pages/Pro';
import WeeklyChallenge from '@/pages/WeeklyChallenge';
import Referral from '@/pages/Referral';
import HallOfFame from '@/pages/HallOfFame';
import Studio from '@/pages/Studio';
import SongRequests from '@/pages/SongRequests';
import TopSongs from '@/pages/TopSongs';
import { PaymentSuccess, PaymentCancel } from '@/pages/Payment';
import InstallPWAPrompt from '@/components/InstallPWAPrompt';

function LocaleWrapper({ children }) {
  const { user } = useAuth();
  return <LocaleProvider user={user}>{children}</LocaleProvider>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/library" element={<ProtectedRoute><SongLibrary /></ProtectedRoute>} />
      <Route path="/song/:id" element={<ProtectedRoute><SongDetail /></ProtectedRoute>} />
      <Route path="/courses" element={<ProtectedRoute><Courses /></ProtectedRoute>} />
      <Route path="/tutor" element={<ProtectedRoute><AITutor /></ProtectedRoute>} />
      <Route path="/community" element={<ProtectedRoute><Community /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      <Route path="/playlists" element={<ProtectedRoute><Playlists /></ProtectedRoute>} />
      <Route path="/playlist/:id" element={<ProtectedRoute><PlaylistDetail /></ProtectedRoute>} />
      <Route path="/pro" element={<ProtectedRoute><Pro /></ProtectedRoute>} />
      <Route path="/challenge" element={<ProtectedRoute><WeeklyChallenge /></ProtectedRoute>} />
      <Route path="/referral" element={<ProtectedRoute><Referral /></ProtectedRoute>} />
      <Route path="/hall-of-fame" element={<ProtectedRoute><HallOfFame /></ProtectedRoute>} />
      <Route path="/studio" element={<ProtectedRoute><Studio /></ProtectedRoute>} />
      <Route path="/requests" element={<ProtectedRoute><SongRequests /></ProtectedRoute>} />
      <Route path="/top-songs" element={<ProtectedRoute><TopSongs /></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LocaleWrapper>
            <AppRouter />
            <Toaster position="top-right" theme="dark" />
            <InstallPWAPrompt />
          </LocaleWrapper>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
